export default __webpack_public_path__ + "static/media/informations-generales.3596b06d.svg";